//React
import React, { Component } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Link } from "react-router-dom";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation, withTranslation } from "react-i18next";
import { CopyToClipboard } from 'react-copy-to-clipboard';

//CSS, STYLES & MEDIA ASSETS
import "./Confirmation.scss";
//import logo from "../../utils/logo_MPDS.svg";
import logo from "../../utils/logo_MPDS_ecossistema.svg";
//import "../../App.scss";

//OUTSIDE COMPONENTS
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Image from 'react-bootstrap/Image'
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField'
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const languages = [
  {
    value: 'pt-PT',
    label: 'Português',

  },
  {
    value: 'en-US',
    label: 'English',
  }
];

function Page() {
  const { i18n } = useTranslation();

  const changeLanguage = (event, lng) => {
    i18n.changeLanguage(event, lng);
  };

  let languageStorage = localStorage.getItem('i18nextLng')
  if (languageStorage != null && languageStorage !== "") {
    if (languageStorage !== "pt-PT" && languageStorage !== "en-US") {
      if (languageStorage.length > 2) {
        let abrvLang = languageStorage.substr(0, 2).toLowerCase();
        if (abrvLang === "en") {
          languageStorage = 'en-US'
        } else {
          languageStorage = 'pt-PT'
        }
      } else {
        languageStorage = 'pt-PT'
      }
    }
  } else {
    languageStorage = 'pt-PT'
  }

  const [values, setValues] = React.useState({
    language: languageStorage
  });

  const handleChange = name => event => {
    setValues({ ...values, [name]: event.target.value });
    /** Change to the clicked language */
    changeLanguage(event.target.value)
  };

  return (
    <div className="text-center pb-5-freetrial mt-idioma">

      <TextField
        id="standard-select-currency"
        select
        inputProps={{ className: "pl-3" }}
        value={values.language}
        onChange={handleChange('language')}
        margin="normal"
      >

        {languages.map(option => (
          <MenuItem key={option.value} value={option.value} dense={true}>
            {option.label}
          </MenuItem>
        ))}


      </TextField>

    </div>
  );
}

class ConfirmationFreeTrial extends Component {
  constructor(props) {
    super(props)
    this.state = { copied: false }
    this.onCopy = this.onCopy.bind(this);
    this.handleCloseSnackBar = this.handleCloseSnackBar.bind(this);
    document.getElementById('root').style.background = "#f4fafb"

  }

  onCopy() {
    this.setState({copied: true});
  }

  handleCloseSnackBar() {
    this.setState({
      copied: false
    })
  }

  render(){
    const { t } = this.props;

    return (
      <Container className="background login-illustration-register">
          <Row className="row-confirmation">
            <Col xs sm md={12} lg={12}>
              <Page />
              <Image src={logo} className="App-logo d-block mx-auto my-md-5 my-3 mb-logo-trial" fluid alt="logo" />
              <label className="bem-vindo mx-auto my-md-5 my-3">{t('FreeTrial.Success')}<br/><span className="label-registrado">{t('FreeTrial.Credentials')}</span></label>
              <br/><br/>
              <div className="out-container">
                <div className="container-registrado">
                  <div className="box-confirmation">
                    <label className="label-box-confirmation-title"><b>Email </b>{this.props.freeTrial.email}</label><br/>
                    <label className="label-box-confirmation-title"><b>Password </b>{this.props.freeTrial.pass}</label>&nbsp;&nbsp;
                    <CopyToClipboard text={this.props.freeTrial.pass}
                        onCopy={this.onCopy}>
                    <img src="..\images\Icon_copy.svg" title={t('FreeTrial.CopyToClipboard')} className="img-copy"></img>
                    </CopyToClipboard>
                    <br/>
                  </div>                
                </div>
                <label className="label-dados-acesso">{t('FreeTrial.DataAcess')}</label>
                <label className="label-descarregou-aplicacao">
                  {t('FreeTrial.DownloadedApp1')} <br/>
                  {t('FreeTrial.DownloadedApp2')} <br/>
                  {t('FreeTrial.DownloadedApp3')} <br/>
                </label>
                <div className="div-buttons-app">
                  <div className="div-img-descarregou-aplicacao">
                    <a href="https://apps.apple.com/app/id1525880827" target="_blank">
                      <img src={t('appstore')} className="mx-auto d-block pt-5 img-descarregou-aplicacao" alt=""></img>
                    </a>
                  </div>
                  <div className="div-img-descarregou-aplicacao">
                    <a href="https://play.google.com/store/apps/details?id=com.mpdswounds" target="_blank">
                        <img src={t('googleplay')} className="mx-auto d-block pt-5 img-descarregou-aplicacao" alt=""></img>
                    </a>
                  </div>
                </div>
                <br/><br/>
                <label className="label-continuar-mpds-freetrial"><span className="label-continuar-mpds-freetrial"><Link to="/">{t('FreeTrial.GoToMpds')}</Link></span></label>
                
                <img width="200px" src="..\images\f3mfeelit-fundobranco.png" className="mx-auto d-block pt-5" alt=""></img>
                <div class="div-sabermais-freetrial pt-3">
                  <label className="label-sabermais-link"><a href={t('urlMpDSSite')} target="_blank">{t('FreeTrial.ClickHere')}</a></label> <label className="label-sabermais">{t('FreeTrial.MoreInformation')}</label>
                </div>
              </div>
            </Col >
          </Row>

          <Snackbar open={this.state.copied} autoHideDuration={5000} onClose={this.handleCloseSnackBar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
              <MuiAlert elevation={6} variant="filled" onClose={this.handleCloseSnackBar} severity="success">
                {t('FreeTrial.Copied')}
              </MuiAlert>
          </Snackbar>
        </Container>
    )
  } 
}

const mapStateToProps = (state, ownProps) => ({ freeTrial: state.freeTrial });
//const mapDispatchToProps = dispatch => bindActionCreators({ login, getToken, resetPassword }, dispatch)
export default withTranslation()(connect(mapStateToProps)(ConfirmationFreeTrial))
